export default __webpack_public_path__ + "static/14-29205954f081313935af41279246fe6a.png";